var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9411,
    cy: 24,
    r: 24,
    transform: "rotate(-45 24.9411 24)",
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2514 13C32.4937 13 32.7188 13.1169 32.8586 13.3098L32.9131 13.3971L36.9198 20.9098L36.9627 21.0122L36.9744 21.05L36.9913 21.1273L37.0006 21.2153L36.9986 21.3147L37.0014 21.25C37.0014 21.3551 36.9797 21.4552 36.9407 21.5461L36.9118 21.6057L36.8712 21.6723L36.8185 21.7408L25.6012 34.7047C25.5011 34.8391 25.364 34.9277 25.2151 34.9703L25.1571 34.9844L25.0597 34.9979L25.0012 35L24.9005 34.9932L24.8154 34.9771L24.7121 34.9432L24.6864 34.931C24.5961 34.8911 24.5131 34.8316 24.4438 34.7535L13.172 21.7263L13.1099 21.6387L13.062 21.5456L13.0273 21.4463L13.0042 21.3152L13.0039 21.1878L13.0188 21.0891L13.0284 21.0499L13.0623 20.9538L13.0896 20.8971L17.0896 13.3971C17.2036 13.1832 17.4127 13.0396 17.6487 13.007L17.7514 13H32.2514ZM28.9074 22H21.0924L25.0024 32.16L28.9074 22ZM19.4864 22H15.3904L22.7634 30.518L19.4864 22ZM34.6094 22H30.5164L27.2434 30.511L34.6094 22ZM21.0254 14.499H18.2004L14.9994 20.5H19.4244L21.0254 14.499ZM27.4244 14.499H22.5774L20.9764 20.5H29.0244L27.4244 14.499ZM31.8014 14.499H28.9764L30.5774 20.5H35.0004L31.8014 14.499Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 24.9411,
    y1: 0,
    x2: 24.9411,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC500"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal3);
export default __webpack_public_path__ + "static/media/goal3.1677d96b662676b4a9ae13af3f8e906e.svg";
export { ForwardRef as ReactComponent };